class NavDropdown extends HTMLElement {
  constructor() {
    super();

    var dropdown = document.querySelector('.navigation__dropdown');
    var navigation = document.querySelector('.header__navigation');
    var header = document.querySelector('header');

    hoverIntent(this, mouseOver);
    hoverIntent(navigation, '', mouseLeave);

    function mouseOver(){
      hideSlideout();
      hideAllNavs();
      removeActiveState();
      hideSearch();
      header.classList.remove('active');

      this.classList.add('active');
      
      dropdown.classList.add('open');

      var linkList = this.getAttribute('data-linklist');
      if (linkList) {
        header.classList.add('active');
        dropdown.querySelector('[data-linklist="' + linkList + '"]').classList.add('active');
      } else {
        dropdown.classList.remove('open');
      }
    };

    function mouseLeave(){
      var dropdown = document.querySelector('.navigation__dropdown');
      dropdown.classList.remove('open');

      header.classList.remove('active');
      
      removeActiveState();
      hideSlideout();
      hideAllNavs();
    }

    function hideAllNavs(){
      var navs = dropdown.querySelectorAll('[data-linklist]');

      for (let index = 0; index < navs.length; index++) {
        const element = navs[index];
        element.classList.remove('active');
      }
    }

    function hideSlideout(){
      var dropdowns = document.querySelectorAll('.navigation__grandchild');

      for (let index = 0; index < dropdowns.length; index++) {
        const element = dropdowns[index];
        element.classList.remove('open');
      }
    }

    function removeActiveState(){
      var dropdowns = document.querySelectorAll('nav-dropdown');

      for (let index = 0; index < dropdowns.length; index++) {
        const element = dropdowns[index];
        element.classList.remove('active');
      }
    }

    function hideSearch() {
      document.dispatchEvent(new CustomEvent('searchDiscovery:close'));
    }
  }
}

customElements.define("nav-dropdown", NavDropdown);